var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ padding: '100px' })},[_c('b',{style:({ padding: '20px 0', fontSize: '20px' })},[_vm._v("Date Picker")]),_c('VModel'),_c('Partial'),_c('WithErrorMessage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }